import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { InlineStylesCSPModule } from './inline-styles-csp.module';
import { NGRX_CONFIG } from './configs/ngrx.config';

import { SharedModule } from '@app/shared/shared.module';

@NgModule({
	imports: [CommonModule, RouterModule, ReactiveFormsModule, InlineStylesCSPModule, ...NGRX_CONFIG.imports, SharedModule],
	declarations: [],
	exports: [],
	providers: [],
})
export class CoreModule {
	constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
		if (parentModule) {
			throw new Error('CoreModule has already been loaded. Import Core modules in the AppModule only.');
		}
	}
}
